module.exports = __webpack_public_path__ + "static/media/buscar-viajes.828e709a.png";